import classNames from 'classnames';

type TabMenuProps<T> = {
  classNameContainer?: string
  tabs: { label: string; value: T }[]
  activeTab: T
  onTabChange: (tab: T) => void
}

export default function TabMenu<T>({ classNameContainer, tabs, activeTab, onTabChange }: TabMenuProps<T>) {
  return (
    <div className={classNames('d-flex align-items-center', classNameContainer)}>
      {tabs.map((tab) => (
        <div
          id={tab.label}
          onClick={() => onTabChange(tab.value)}
          className={classNames('pointer p-2', {
            'text-secondary': tab.value === activeTab,
            'border-bottom border-secondary': tab.value === activeTab,
            'border-bottom': tab.value !== activeTab,
            'text-body-secondary': tab.value !== activeTab,
          })}
        >
          {tab.label}
        </div>
      ))}
    </div>
  )
}
